import {useMutation} from "@tanstack/react-query";
import * as uniqueApi from "../services/unique.api";

export const usePutUnique = () =>
	useMutation({
		mutationFn: (data) => uniqueApi.putUnique(data),
	});
